<!-- Header -->
<header id="one">
    <div class="hero">
      <div fxLayout="row wrap"></div>
      <h1>UMEX facilite vos <br>déplacements professionnels</h1>
      <h2>Accédez à des véhicules disponibles partout <br>au Senegal 24h/24 et 7j/7</h2>
    </div>
  </header>
<!-- Info Squares -->
  <section class="section mt-3 px-3 info-squares">
    <div class="no-gutter wrap" fxLayout="row wrap" fxLayoutAlign="center">
      <div fxFlex="100" fxFlex.gt-sm="30">
        <div class="square">
          <mat-icon class="icon">more_time</mat-icon>
          <h4>Gain de temps</h4>
          <p>Une réservation rapide et digitale. Un état <br>des lieux effectué en 5 min.  </p>
        </div>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="30">
        <div class="square">
          <mat-icon class="icon">security</mat-icon>
          <h4>Trajets 100% assurés</h4>
          <p>Chaque location est assurée tous risques <br> par Axa, et couverte par l’assistance <br>routière 24h/24 et 7j/7.</p>
        </div>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="30">
        <div class="square">
          <mat-icon class="icon">done_all</mat-icon>
          <h4>Service client disponible 7j/7</h4>
          <p>Pour que vous ne soyez jamais laissé au bord <br>de la route, notre équipe est à votre écoute.</p>
        </div>
      </div>
    </div>
  </section>
<!-- Services -->
  <section id="two" class="servies">
    <div class="container">
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="title">
          <h6>Fonctionnalités</h6>
          <p>Des fonctionnalités pour votre entreprises</p>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div fxFlex="100" fxFlex.gt-sm="10"></div>
        <div fxFlex="100" fxFlex.gt-sm="60">
          <div fxLayout="row wrap" fxLayoutAlign="center">
            <div fxFlex="100" fxFlex.gt-sm="50">
              <div class="service-text">
                <mat-icon class="icon-service">calculate</mat-icon>
                <h4>Une comptabilité simplifiée</h4>
                <p>Vos reçus de paiements au nom de l'entreprise, et la possibilité de sortir vos factures de TVA</p>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50">
              <div class="service-text">
                <mat-icon class="icon-service">diversity_3</mat-icon>
                <h4>Gestion de votre équipe</h4>
                <p>Ajoutez et retirez vos membres d'équipe à votre guise et sans limites</p>
              </div>
            </div>
          </div>    
          <div fxLayout="row wrap" fxLayoutAlign="center">
            <div fxFlex="100" fxFlex.gt-sm="50">
              <div class="service-text">
                <mat-icon class="icon-service">payments</mat-icon>
                <h4>Paiement centralisé</h4>
                <p>Un moyen de paiement unique pour les déplacements de tous vos membres d'équipe.</p>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50">
              <div class="service-text">
                <mat-icon class="icon-service">important_devices</mat-icon>
                <h4>UMEX Connect</h4>
                <p>Fini la perte de temps au guichet d'un loueur traditionnel, des véhicules disponibles 7j/7 et 24h/24.</p>
              </div>
            </div>
          </div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30">
          <div class="service-img">
            <img [src]="getHost.getHttpsImage() + 'imageEntreprise/image2.jpg'" alt="">
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="show-more-btn">
          <div class="btn-wrap">
            <!-- serge 25/03/2025 -->
            <a routerLink="/create-enterprise" class="button2">Créer mon Espace Entreprise <mat-icon>trending_flat</mat-icon></a>
          </div>
        </div>
      </div>
    </div>
  </section>
<!-- Portfolio -->
  <section id="three" class="portfolio">
    <div class="container">
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="title">
          <h6>SILOKA</h6>
          <p>Un service qui s'adapte à vos déplacements</p>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div fxFlex="100" fxFlex.gt-sm="30" class="portfolio-item">
          <a class="hover01" href="#">
            <figure><img class="img-fluid" [src]="getHost.getHttpsImage() + 'imageEntreprise/image3.jpg'" alt=""></figure>
          </a>
          <div class="portfolio-caption">
            <h4>Rendez-vous clients</h4>
            <p>Siloka met à votre disposition des véhicules afin de faciliter vos déplacements, arriver à temps à vos rendez-vous client, des véhicules de qualité</p>
          </div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30" class="portfolio-item">
          <a class="hover01" href="#">
            <figure><img class="img-fluid" [src]="getHost.getHttpsImage() + 'imageEntreprise/image4.jpg'" alt=""></figure>
          </a>
          <div class="portfolio-caption">
            <h4>Transport de matériel</h4>
            <p>Nous possédons des véhicules vous permettant de transporter votre matériel en toute sécurité,en fonction du type de matériels à transporter</p>
          </div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30" class="portfolio-item">
          <a class="hover01" href="#">
            <figure><img class="img-fluid" [src]="getHost.getHttpsImage() + 'imageEntreprise/image5.jpg'" alt=""></figure>
          </a>
          <div class="portfolio-caption">
            <h4>Transport du Personnel</h4>
            <p>Umex met à votre disposition des véhicules assurant le transport et la sécurité de votre personnel, depuis leur domicile pour votre entreprise</p>
          </div>
        </div>
      </div>
    
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="show-more-btn">
          <div class="btn-wrap">
            <!-- serge 25/03/2025 -->
            <a routerLink="/create-enterprise" class="button2">Créer mon Espace Entreprise <mat-icon>trending_flat</mat-icon></a>
          </div>
        </div>
      </div>
    </div>
  </section>
<!-- About -->
  <section id="four" class="about">
    <div class="container">
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="title">
          <h6>A propos</h6>
          <p>En savoir plus sur nous</p>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div fxFlex="100" fxFlex.gt-sm="30" class="about-img" fxLayoutAlign="center">
          <img  [src]="getHost.getHttpsImage() + 'imageEntreprise/image6.jpg'" alt="">
        </div>
        <div fxFlex="100" fxFlex.gt-sm="70" class="about-text">
          <h4>Umex est une plateforme sécurisée de location de voitures et d’utilitaires basée sur la consommation collaborative. Le concept propose un usage plus simple et plus flexible de la voiture avec la possibilité pour l’utilisateur ou entreprise locataire de louer un véhicule en quelques clics,à chaque instant, partout en Cote d'ivoire.</h4>
          <div class="separator"></div>
          <p>Nous faisons ainsi bénéficier à nos locataires d’une solution bon marché, 30 à 40% moins chère que chez les loueurs traditionnels, pour se déplacer simplement et quand il le souhaite, le temps d’un week-end, d’un déménagement, d’un déplacement professionnel ou d’une semaine de vacances. Chacun y trouve son compte, c’est un service gagnant-gagnant !</p>
          <p><a>En savoir plus ? <mat-icon>trending_flat</mat-icon></a></p>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center">
      <div class="show-more-btn">
        <div class="btn-wrap">
          <!-- serge 25/03/2025 -->
          <a routerLink="/create-enterprise" class="button2">Créer mon Espace Entreprise <mat-icon>trending_flat</mat-icon></a>
        </div>
      </div>
    </div>
  </section>
<!-- Contact -->
  <section id="five" class="contact">
    <div class="container">
      <div fxLayout="row wrap" fxLayoutAlign="center">
        <div class="title">
          <h6>Questions</h6>
          <p> <a routerLink="/faq">Que souhaitez vous savoir <mat-icon>help_outline</mat-icon></a></p>
        </div>
      </div>
    </div>
  </section>